import React, { useContext, useState } from 'react'
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import styles from "./timePopUp.module.css";
import Button from '../../../button';
import arrow_logo from "../../../../assets/arrow_blue.png"
import { CreateNewSchedule } from '../../../../utils/shedule';
import { notify } from '../../../toast';
import { AuthContext } from '../../../../contextAPI';

const TimePopUp = (props) => {

  const hours = ["00","01","02","03","04","05","06","07","08","09","10","11","12","13","14","15","16","17","18","19","20","21","22","23"]
  const minutes = ["00","05","10","15","20","25","30","35","40","45","50","55"]

  const existing_schedule = props.lastTodaysTime;
  let default_time = "09:00"
  
  existing_schedule && existing_schedule.map(obj => {
    if(obj.time > default_time){
      default_time = obj.time
    }
    return ""
  })  

  const [hoursIndex, setHoursIndex] = useState(hours.indexOf(default_time[0] + default_time[1]))
  const [minutesIndex, setMinutesIndex] = useState(2)

  const Auth = useContext(AuthContext);
  const token = Auth.isLoggedIn ? Auth.authenticatedUser.token.access_token : null

  const increaseHoursHandler = () => {
    if(hoursIndex === hours.length - 1)return setHoursIndex(0)
    setHoursIndex(hoursIndex+1)
  }

  const decreaseHoursHandler = () => {
    if(hoursIndex === 0)return setHoursIndex(hours.length-1)
      setHoursIndex(hoursIndex-1)
  }

  const increaseMinutesHandler = () => {
    if(minutesIndex === minutes.length - 1)return setMinutesIndex(0)
      setMinutesIndex(minutesIndex+1)
  }

  const decreaseMinutesHandler = () => {
    if(minutesIndex === 0)return setMinutesIndex(minutes.length-1)
      setMinutesIndex(minutesIndex-1)
  }

  const submitHandler = async() => { 

    try {

      const response = await CreateNewSchedule({
        schedule_date: props.selectedDate,
        work_hours: `${hours[hoursIndex]}:${minutes[minutesIndex]}`,
        project_id: process.env.REACT_APP_PROJECT_ID,
      },token)


      if(!response.status || !response.data)throw new Error(response.message)

      return props.onShowSchedule(response.data);

    } catch (error) {
      notify(error.message || "Negalimas veiksmas", "error")
    }
  }

  return (
    <div className={styles.container}>

      <div className={styles.clock}>

        <div className={styles.time_picker}>
          <img alt='+' src={arrow_logo} onClick={increaseHoursHandler} />
          <h1>{hours[hoursIndex]}</h1>
          <img alt='-' className={styles.rotated_arrow} src={arrow_logo} onClick={decreaseHoursHandler} />
        </div>

        <span className={styles.time_picker_span}>:</span>

        <div className={styles.time_picker}>
          <img alt='+' src={arrow_logo} onClick={increaseMinutesHandler} />
          <h1>{minutes[minutesIndex]}</h1>
          <img alt='-' className={styles.rotated_arrow} src={arrow_logo} onClick={decreaseMinutesHandler} />
        </div>

      </div>

      <div className={styles.footer}>
        <Button onClick={submitHandler}>Pridėti</Button>
      </div>

    </div>
  );
}

export default TimePopUp